module.exports = __webpack_public_path__ + "static/media/Rewards.2855ac2d.svg";